export default {
  errorDefault: 'Възникна грешка',
  unknown: 'Неизвестно',
};
